/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

function Backdrop(props) {
  return <div className="omi-backdrop" onClick={props.click} />;
}

export default Backdrop;
